import React, {useState, useEffect, useCallback} from 'react';

import p1_bImg from '../../assets/img/p1_b_01.b78c060f.jpg';
import pay1_btn from '../../assets/img/panic_buying_btn.png';
import pay2_btn from '../../assets/img/panic_buying_btn.png';
 import pay3_btn from '../../assets/images/lingquBtn.png';
 import pay4_btn from '../../assets/images/baomingBtn.png';
// import bg1 from '../../assets/img/2020.10_01.jpg';
// import bg2 from '../../assets/img/2.png';
// import bg3 from '../../assets/img/3.png';
// import bg4 from '../../assets/img/4.png';
// import bg5 from '../../assets/img/5.png';
// import bg6 from '../../assets/img/6.png';

// 跳动按钮模块
import an_bg7 from '../../assets/img/2020.10_02.jpg';
import an_bg8 from '../../assets/img/优惠券.png';
import an_bg9 from '../../assets/img/优惠btn.png';
// import bg7 from '../../assets/img/7.png';

// 更改推广页主页面
 import bg1 from '../../assets/images/xiaoniu_1.jpg';
 import bg2 from '../../assets/images/xiaoniu_2.jpg';
 import bg3 from '../../assets/images/xiaoniu_3.jpg';
 import bg4 from '../../assets/images/xiaoniu_4.jpg';
 import bg5 from '../../assets/images/xiaoniu_5.jpg';
 import bg6 from '../../assets/images/xiaoniu_6.jpg';
 import bg7 from '../../assets/images/xiaoniu_7.jpg';
 import bg8 from '../../assets/images/xiaoniu_8.jpg';
 import bg9 from '../../assets/images/xiaoniu_9.jpg';
 import bg10 from '../../assets/images/xiaoniu_10.jpg';
 import bg11 from '../../assets/images/xiaoniu_11.jpg';
 import bg12 from '../../assets/images/xiaoniu_12.jpg';
 import bg13 from '../../assets/images/xiaoniu_13.jpg';
 import bg14 from '../../assets/images/xiaoniu_14.png';
 import bg15 from '../../assets/images/xiaoniu-new.jpg';


import countDown_btn from '../../assets/images/download.png';
import limited from '../../assets/images/buying_btn.png';
import style from './style.module.css'
import Mypopuptwo from "../OderInfo/Mypopupthree"
// import {getUrl} from '../../utils/tool'
import {useUrlQuery} from '../../utils/useFunc'
import ProtocolDetails from '../ProtocolDetails/index';

import a from '../../assets/cx-img/img-1.png'
import b from '../../assets/cx-img/img-2.png'
import c from '../../assets/cx-img/img-3.png'
import d from '../../assets/cx-img/img-4.png'
import e from '../../assets/cx-img/img-5.png'
import f from '../../assets/cx-img/img-6.png'
import g from '../../assets/cx-img/img-7.png'
import h from '../../assets/cx-img/img-8.png'
import i from '../../assets/cx-img/img-9.png'
import j from '../../assets/cx-img/img-10.png'
import k from '../../assets/cx-img/img-11.png'
import l from '../../assets/cx-img/img-12.png'
import m from '../../assets/cx-img/img-13.png'
import n from '../../assets/cx-img/img-14.png'
import btn_a from '../../assets/cx-img/btn.png'
import back_btn from '../../assets/cx-img/back-btn.png'
import btn_btn from '../../assets/cx-img/btn-btn.png'

const images = [ a,b,c,d,e,f,g,h,i,j,k,l,m,n ]

// const contentBackImage = [
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/01c92aa769e6fbf04ff2e621d4c09987.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/a167bbfa0fc3464d8e867b7648ea5bc2', k:'1' },
//     // { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/fbc2269c2a805c1f37aadb2ea02da68e.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/4d89da41a2e84fd6a0e45d71cc97601f', k:'2' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747238400000/869d7c8ac563aa364c39eb91a60b504b.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/86a1f52ef4074df68476e84691d89257', k:'3' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/7dee4493bae7d4149fb59a080d4017dd.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/10b8bd520eff4b708d3bbc64bdc55db9', k:'4' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/745dbb569bcbd3ee8c907983536bb3c1.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1d11b69de2794b56a3197a3b6d736f1f', k:'5' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/436b1862203e1aa112d04d96a1975321.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/c73bc937a94d4025b3a7a6cc40727c2b', k:'6' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/0cff1488e546a7a672f1e6debc722278.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/848246c5c39c4f658b3f3994c159adb4', k:'7' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/2596e8bb9d6f4f22bf1b131dfe65c556.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/b4c8d7420b47419b9939af3862c3d040', k:'8' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747238400000/c8d30fec5782e000da428939f6f17e52.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/ddec220815cf45968bcc4819828fc96f', k:'9' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/cae69d83059e79965ece4d1013fd83db.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/a13df865c0ce4be9a9b06dfedeb2f44e', k:'10' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/09fef303481e6e848b8058d58870d477.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/42c98936e3024e548d35acfdff0638c6', k:'11' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/69585926b3760ee97701357462983ebe.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/5cd5a50d45934b44808075ca46daebc1', k:'12' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/a256ea7e201241e0df6964c96f7d06a5.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/35579621e38f43e595bba850e7400dac', k:'13' },
//     { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1747324800000/a17ceeb92db646303b0cf9f92168d0cf.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/158580e8c48649c2943123a8bd236667', k:'14' },
// ]
const contentBackImage = [
    // envVersion 2025-07-07
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/13c170d2a63657bae715473373bf3417.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/36378cc6f1d04f968b63ba8e4eb920f8.webp', k:'1' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/75eadfc3eed2fdc97324272520ed32bb.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/a62a6aca09b249258875553250e90e36.webp', k:'2' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/4fe489895150c7dfdaa457491beb0704.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/5f24c0eb4d6149bca7a0af8df3f349f6.webp', k:'3' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/2f61dc2574bba0551ee2303016cdd07e.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/ea84c3cd2f8440ccb33d9f9cc65fc7dd.webp', k:'4' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/aed060e3275ec7b5fa0500401d9d193c.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/b1f3640c816f449f81ad2cbc2762807a.webp', k:'5' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/7b866030ec133f68b603b2c64447789e.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/b1f3640c816f449f81ad2cbc2762807a.webp', k:'6' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/adacf025efbc0282375478a9688e3bef.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/a103016ec71b4efd91dca36a3b66f1f3.webp', k:'7' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/1907acc06eb539d001668fc792c1e643.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/9a85da22612940f0ae2d7a25c8548c01.webp', k:'8' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/1b374735f60d10dce369a9b35b0f5ff5.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/b1a790644c1a4d14b5defc6bbcc4b57f.webp', k:'9' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/87f75d8a9f7d927aa362b23d7d39bbc7.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/0939343458a549eb9180db87a8f8def1.webp', k:'10' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/c9817dc99ac4d0e198bbcecca89f7c81.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/5439bca6754745e8ae2a48cd483ca3fb.webp', k:'11' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/d8abda124f3f198f26d643b7fd34b454.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/9e7e398789214c95b2924a2c7f584def.webp', k:'12' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/6931e5e73031567e405a6c7e8829b19b.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/58ee5b3ffb9f439b85c7586618e61943.webp', k:'13' },
    { url:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1751817600000/6f9f0280c714b47fb582bf9e0eb98d8e.png', webp:'https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/fa157b949df4458ab1e97f7e42613377.webp', k:'14' },
]
// const contentBackImage = [
//     // envVersion 2
//     { url:'htt', webp:'htt', k:'1' },
//     { url:'htt', webp:'htt', k:'2' },
//     { url:'htt', webp:'htt', k:'3' },
//     { url:'htt', webp:'htt', k:'4' },
//     { url:'htt', webp:'htt', k:'5' },
//     { url:'htt', webp:'htt', k:'6' },
//     { url:'htt', webp:'htt', k:'7' },
//     { url:'htt', webp:'htt', k:'8' },
//     { url:'htt', webp:'htt', k:'9' },
//     { url:'htt', webp:'htt', k:'10' },
//     { url:'htt', webp:'htt', k:'11' },
//     { url:'htt', webp:'htt', k:'12' },
//     { url:'htt', webp:'htt', k:'13' },
//     { url:'htt', webp:'htt', k:'14' },
// ]
var computePX = function(devBase, nowBase) {
    var ratio = nowBase / devBase;
    return function(devPx) {
        return ratio * devPx;
    };
}

function randomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
}
export default () => {
    let {sku_id,qudao,pri} = useUrlQuery(); //获取url上的sku_id和渠道
    let [timer, setTimer] = useState(null);
    let [hour, setHour] = useState('08');
    let [minute, setMinute] = useState('00');
    let [second, setSecond] = useState('00');
    let [priceType, setPriceType] = useState(limited);
    let [agrement, setAgrement] = useState(false);
    let [visible, setVisible] = useState(false);
    let [width, setWidth] = useState('');
    let [marginleft, setMarginleft] = useState('');

    const [modal2, setModal2] = useState(false)

    let [sum, setSum] = useState('98');
    let [td, setTd] = useState('9');
    let [ud, setUd] = useState('8');

    let [nowTime] = useState(new Date().getTime());
    // 是否显示用户协议
    function showAgrement(bol){
        if(bol == true){
            setVisible(() => true)
        }else{
            setVisible(() => false)

        }
        setAgrement(() => bol)
    }
    // 判断是否在微信内
    function isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            setWidth(() => computePX(375, window.innerWidth)(36) + 'px')
            setMarginleft(() => computePX(375, window.innerWidth)(6) + 'px')
        } else {
            setWidth(() => computePX(375, window.innerWidth)(16) + 'px')
            setMarginleft(() => computePX(375, window.innerWidth)(0) + 'px')
        }
    }

    function formatTime(num){
        let dateNum = num + '';
        if(dateNum.length === 1){
            return '0' + num;
        }else{
            return num
        }
    }
    // 八小时候的时间
    function formatDate(date){
        return date + 3600000  * 8;
    }
    //时间
    const countDownTime = useCallback((time,nowDate,countTime) => {
        // 时
        let getDatTimeHour =(time - nowDate) % (24 * 3600 * 1000)
        let timestampHour = Math.floor(getDatTimeHour / (3600 * 1000));
        // 分
        let getDatTimeMinute = getDatTimeHour %  (3600 * 1000);
        let timestampMinute = Math.floor(getDatTimeMinute / (60 * 1000));
        // 秒
        let getDatTimeSecond = getDatTimeMinute % (60 * 1000);
        let timestampSecond = Math.floor(getDatTimeSecond / 1000);
        setHour(formatTime(timestampHour));
        setMinute(formatTime(timestampMinute));
        setSecond(formatTime(timestampSecond));
        if((parseInt(timestampHour) === 0) && (parseInt(timestampMinute) === 0) && (parseInt(timestampSecond) === 0)){
            sessionStorage.removeItem('deadlineDate')
            clearInterval(countTime)
        }
    },[])
    // 获取sku_id
    // 获取sku_id，url没有就设置默认值
    if(sku_id){
        sessionStorage.setItem('sku_id',sku_id);
        localStorage.setItem('sku_id',sku_id);
        sessionStorage.setItem('pri',pri);
        localStorage.setItem('pri',pri);
        /*sessionStorage.setItem('url',window.location.href);
        localStorage.setItem('url',window.location.href);*/
        sessionStorage.setItem('url','p3');
        localStorage.setItem('url','p3');
    }else{
        sessionStorage.setItem('sku_id',1);
        localStorage.setItem('sku_id',1)
        sessionStorage.setItem('pri',0.99);
        localStorage.setItem('pri',0.99)
        /*sessionStorage.setItem('url',window.location.href);
        localStorage.setItem('url',window.location.href);*/
        sessionStorage.setItem('url','p3');
        localStorage.setItem('url','p3');
    }
    useEffect(() =>{
        // 根据sku_id判断商品价格
        if((sessionStorage.getItem('sku_id') == 1) || (localStorage.getItem('sku_id') == 1)){
            setPriceType(limited)
        }else{
            setPriceType(limited)
        }
        isWeiXin();
    },[])

    // 获取渠道
    useEffect(() =>{
        if(qudao){
            sessionStorage.setItem('channel',qudao);
            localStorage.setItem('channel',qudao);

        }else{
            sessionStorage.setItem('channel','tengxun');
            localStorage.setItem('channel','tengxun');
        }
    },[qudao])

    useEffect(() => {
        const loca = localStorage.getItem('collection-cookie') || null
        if(!loca) {
            localStorage.setItem('collection-cookie', randomString(20))
        }
    },[])
    useEffect(() => {
        sessionStorage.setItem('payshow',false)
        let hash = window.location.hash;
        hash = hash.indexOf('checked=true');
        if(hash != -1){
            setModal2(true);
        }
    },[])

    //名额倒计时
    useEffect(() => {
        let tiemId = setInterval(() => {
            sum = sum - parseInt((2*Math.random())+1);
            td = parseInt((sum%100)/10);
            ud = parseInt(sum%10)
            setSum(sum)
            setTd(td)
            setUd(ud)
            sessionStorage.setItem('sumNber',sum)
            if(sum <=5){
                clearInterval(tiemId)
                setTd(0)
                setUd(5)
            }
        }, 5000);
    },[])

    // 计时器
    useEffect(() => {
        let countTime = 0;
        if(!timer){
            setTimer(1);
            countTime = setInterval(() => {
                if(!sessionStorage.getItem('deadlineDate')){
                    sessionStorage.setItem('deadlineDate',formatDate(nowTime))
                    countDownTime(formatDate(nowTime),nowTime,countTime)

                }else{
                    countDownTime(sessionStorage.getItem('deadlineDate'),new Date().getTime(),countTime);
                }
            }, 1000)
        };
        return function clearCountTime(){
            if(timer){
                clearInterval(countTime)
            }
        }
    },[timer,setTimer,countDownTime,nowTime]);


    let timerStyle = {
        right: computePX(375, window.innerWidth)(66.5) + 'px',
        bottom: computePX(375, window.innerWidth)(80) + 'px'
    }
    let timeShare = {
        // width: computePX(375, window.innerWidth)(16) + 'px',
        width: width,
        height: computePX(375, window.innerWidth)(14) + 'px',
        marginleft: marginleft
    }

    let imgWidth = {
        width: computePX(375,window.innerWidth)(130) + 'px',
        height: computePX(375,window.innerWidth)(35) + 'px'
    }
    return <div>
        <div className={style.content}>
            {/* <img alt="图片" className={style.contentBD} src="https://wechattool-pro-news.oss-cn-chengdu.aliyuncs.com/1736956800000/1f88355858e8aa19230ea78c5d3fdb34.png"></img> */}
            {/* <img alt="图片" style={{width: '100%'}} src={p1_bImg}></img> */}
            {/* <div style={{width: '100%'}} className={style.couponBox}>
                <img style={{width: '100%'}} alt="图片" src={an_bg7}></img>
                <img alt="图片" src={an_bg8} className={style.coupon} onClick={() => setModal2(true)}></img>
                <img alt="图片" src={an_bg9} className={style.couponBtn} onClick={() => setModal2(true)}></img>
            </div> */}
            
            {/* 2024-4-30 -修改前 */}
            {/* <img alt="图片" style={{width: '100%'}} src={bg1}></img>
            <img alt="图片" style={{width: '100%'}} src={bg2}></img>
            <img alt="图片" style={{width: '100%'}} src={bg3}></img>
            <img alt="图片" style={{width: '100%'}} src={bg4}></img>
            <img alt="图片" style={{width: '100%'}} src={bg5}></img>
            <img alt="图片" style={{width: '100%'}} src={bg6}></img>
            <img alt="图片" style={{width: '100%'}} src={bg7}></img>
            <img alt="图片" style={{width: '100%'}} src={bg8}></img>
            <img alt="图片" style={{width: '100%'}} src={bg9}></img>
            <img alt="图片" style={{width: '100%'}} src={bg10}></img>
            <img alt="图片" style={{width: '100%'}} src={bg11}></img>
            <img alt="图片" style={{width: '100%'}} src={bg12}></img>
            <img alt="图片" style={{width: '100%'}} src={bg13}></img>
            <img alt="图片" style={{width: '100%'}} src={bg14}></img>  */}


            {/* 2024-4-30 -修改 */}
            {
                contentBackImage.map((it,k) => {
                    return <>  
                       <picture key={k}>
                            <source style={{width: '100%'}} srcset={it.webp} type="image/webp" />
                            <img style={{width: '100%'}} src={it.url} alt="fallback" />
                        </picture>
                    </>
                    // return <img alt="图片" style={{width: '100%'}} key={k} src={it}></img>
                })
            }
            <img alt="图片" className={style.btn_a_style}  src={btn_a} onClick={() => setModal2(true)}></img>

           
            {/*<img alt="图片" style={{width: '100%'}} src={bg7}></img>*/}
            {/* <div className={style.btn1}>
            <img alt="图片" style={{width: '100%'}} src={pay3_btn} onClick={() => setModal2(true)}></img>
            </div> */}
            {/* <div className={style.btn2}>
            <img alt="图片" style={{width: '100%'}} src={pay4_btn} onClick={() => setModal2(true)}></img>
            </div> */}
        </div>
       
        <div className={style.submit}>
            {/* 2024-4-30 -修改 */}
            <img alt="图片" style={{width: '100%'}} src={back_btn} onClick={() => setModal2(true)}></img>
            {/* 2024-4-30 -修改前 */}
            {/* <img alt="图片" style={{width: '100%'}} src={limited} onClick={() => setModal2(true)}></img> */}

            {/* <div className={style.submit_num} style={timerStyle}>
                <span className={style.num1}>{td}</span>
                <span className={style.num2}>{ud}</span>
            </div> */}
            <div className="box_scale" style={imgWidth} className={style.countDown_btn}>
                <img alt="图片" style={{width: '100%'}} src={btn_btn} onClick={() => setModal2(true)}></img>
                {/* <img alt="图片" style={{width: '100%'}} src={countDown_btn} onClick={() => setModal2(true)}></img> */}
                {/* <div className={style.timeDown} style={timerStyle}>
                    <div className={style.hour} style={timeShare}>{ hour }</div>
                    <div className={style.minute} style={timeShare}>{ minute }</div>
                    <div className={style.second} style={timeShare}>{ second }</div>
                </div> */}

            </div>

        </div>
        <Mypopuptwo visible={modal2} onClose={() =>setModal2(false)} timeData={sum} afterClose={()=>{}} sku_id={localStorage.getItem('sku_id')} pri={localStorage.getItem('pri')} changeShow={showAgrement}/>
        {
            agrement ?
                <div className={style.contract}>
                    <ProtocolDetails changeShow={showAgrement} visible={visible}/>
                </div>
                :
                null
        }

    </div>;
}
